import { Typography, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(theme => ({
  highlight: {
    backgroundColor: theme.palette.primary.main, // Puedes cambiar el color
    color: theme.palette.primary.contrastText // Ajusta el color del texto si es necesario
    // padding: '0 4px'
  }
}));
const HighlightedTypography = ({ children, highlight, ...props }) => {
  const classes = useStyles();
  if (!highlight) {
    return <Typography {...props}>{children}</Typography>;
  }
  const parts = children.split(new RegExp(`(${highlight})`, 'gi'));
  return (
    <Typography {...props}>
      {parts.map(
        (part, index) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <span key={index} className={classes.highlight}>
              {part}
            </span>
          ) : (
            part
          )
      )}
    </Typography>
  );
};

export default HighlightedTypography;
